let handler: any;

export const outside = {
    bind(el: any, binding: any, vnode: any) {

        handler = (event: Event) => {
            if (!(el === event.target || el.contains(event.target))) {
                if (typeof (binding.value) === 'function') {
                    binding.value();
                } else {
                    alert('[Vue-Outside:] provided expression' + binding.expression + 'is not a function.');
                }
            }
        };
        document.addEventListener(binding.arg, handler);
    },

    unbind(el: any, binding: any, vnode: any) {
        document.removeEventListener(binding.arg, handler);
    }
};
